var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AuthContainer',{scopedSlots:_vm._u([{key:"form",fn:function(){return [_c('SubscriptionOutcome')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }